import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  getQuantamHistory  } from '../../api'; // Import from api.js


// Async thunk for fetching dashboard data
export const fetchAboutHistoryData = createAsyncThunk(
  'getQuantamHistory/fetchAboutHistoryData',
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await getQuantamHistory();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch aboutOverview data');
    }
  }
);

const aboutHistorySlice = createSlice({
  name: 'aboutOverview',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAboutHistoryData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAboutHistoryData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAboutHistoryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = aboutHistorySlice.actions;
export default aboutHistorySlice.reducer;
